module.exports = __webpack_public_path__ + "media/images/riders/MARCELLO_GUTIERREZ-12543d98b12ff2e053d8b75457d9f51a.png";